export var TimePeriodPickerDictionary = {
    DaysPlaceholder: "DD",
    HoursPlaceholder: "HH",
    MinutesPlaceholder: "MM",
};
export var TimePeriodPickerDefaultConfig = {
    onChange: function () { },
    hasDays: false,
    dict: TimePeriodPickerDictionary
};
//# sourceMappingURL=TimePeriodPickerConfig.js.map